import mixpanel from 'mixpanel-browser';
import clarity from '@microsoft/clarity';
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserId as setFirebaseUserId, setUserProperties as setFirebaseUserProperties } from 'firebase/analytics';
import { AnalyticsConfig } from '../components/Analytics/utils/analyticsConfig';
import firebaseConfig from '@firebaseConfig';

let firebaseAnalytics = null;

export const initAnalytics = () => {
  if (!AnalyticsConfig.globalEnabled) {
    console.log('[Analytics] Global kill-switch is active. Analytics disabled.');
    return;
  }

  // 1. Initialize Mixpanel
  if (AnalyticsConfig.mixpanel.enabled) {
    try {
      mixpanel.init(AnalyticsConfig.mixpanel.token, {
        debug: AnalyticsConfig.mixpanel.debug,
        track_pageview: AnalyticsConfig.mixpanel.trackPageView,
        persistence: AnalyticsConfig.mixpanel.persistence,
        ignore_dnt: AnalyticsConfig.mixpanel.ignore_dnt,
      });
    } catch (e) {
      console.error('[Analytics] Failed to initialize Mixpanel:', e);
    }
  }

  // 2. Initialize Microsoft Clarity
  if (AnalyticsConfig.clarity.enabled) {
    try {
      clarity.init(AnalyticsConfig.clarity.projectId);
    } catch (e) {
      console.error('[Analytics] Failed to initialize Clarity:', e);
    }
  }

  // 3. Initialize Firebase / GA4
  if (AnalyticsConfig.ga4.enabled && firebaseConfig?.result?.sdkConfig) {
    try {
      const app = initializeApp(firebaseConfig.result.sdkConfig);
      firebaseAnalytics = getAnalytics(app);
    } catch (e) {
      console.error('[Analytics] Failed to initialize Firebase Analytics:', e);
    }
  }
};

export const trackEvent = (eventName, properties = {}) => {
  if (!AnalyticsConfig.globalEnabled) return;

  if (AnalyticsConfig.mixpanel.enabled) {
    mixpanel.track(eventName, properties);
  }

  if (AnalyticsConfig.ga4.enabled && firebaseAnalytics) {
    logEvent(firebaseAnalytics, eventName, properties);
  }

};

export const trackPageView = (path) => {
  if (!AnalyticsConfig.globalEnabled) return;

  if (AnalyticsConfig.mixpanel.enabled) {
    mixpanel.track('page_view', { page_path: path });
  }

  if (AnalyticsConfig.ga4.enabled && firebaseAnalytics) {
    logEvent(firebaseAnalytics, 'page_view', { page_path: path });
  }
};

export const setUserId = (userId) => {
  if (!AnalyticsConfig.globalEnabled) return;

  if (AnalyticsConfig.mixpanel.enabled) {
    mixpanel.identify(userId);
  }

  if (AnalyticsConfig.clarity.enabled) {
    try {
      clarity.identify(userId);
    } catch (e) {
      console.error("[Analytics] Clarity identification failed", e);
    }
  }

  if (AnalyticsConfig.ga4.enabled && firebaseAnalytics) {
    setFirebaseUserId(firebaseAnalytics, userId);
  }
};

export const setUserProperties = (properties) => {
  if (!AnalyticsConfig.globalEnabled) return;

  if (AnalyticsConfig.mixpanel.enabled) {
    mixpanel.people.set(properties);
  }

  if (AnalyticsConfig.ga4.enabled && firebaseAnalytics) {
    setFirebaseUserProperties(firebaseAnalytics, properties);
  }

};
